<ppt-actions-toolbar
  [reportData]="reportData()"
  [currentView]="currentView()"
  [recordsCount]="propertiesCount"
  (navRecordNum)="navRecordNum($event)"
  [requiresSelectTempElement]="false"
></ppt-actions-toolbar>

<div class="container">
  <div class="col"></div>
  <div class="navbar">
    <ul class="navigation-list">
      @if (property.header?.propertyName) {
        <li class="navigation-item">
          <a (click)="goToRecord()" class="action-element">
            <u>{{ property.header.propertyName }}</u>
            @if (property.header?.propertyAddress) {
              <p>
                <small
                  ><u>{{ property.header.propertyAddress }}</u></small
                  >
                </p>
              }
            </a>
          </li>
        }
        <li class="navigation-item"><strong>{{ 'template.status' | translate }}</strong>{{ property.header?.status }}</li>
        <li class="navigation-item"><strong>{{ 'template.completed' | translate }}</strong> {{ property?.year }}</li>
      </ul>
    </div>

    <div class="sidebar">
      <rep-development-pipeline-view-image
        [propertyImages]="property.images"
        [property]="property"
        [reportId]="reportData().reportId"
        >
      </rep-development-pipeline-view-image>
    </div>
    <div class="main-content">
      <h3 class="property-title">{{ 'template.availableAccommodation' | translate }}</h3>
      @if (property.availableAccomodations?.floors) {
        <div>
          <mat-table [dataSource]="property.availableAccomodations.floors" class="mat-elevation-z0">
            <ng-container matColumnDef="FLOOR">
              <mat-header-cell *matHeaderCellDef>{{ 'template.floor' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.floor }} </mat-cell>
              <mat-footer-cell *matFooterCellDef>{{ 'template.total' | translate }}</mat-footer-cell>
            </ng-container>
            <ng-container matColumnDef="SQM">
              <mat-header-cell *matHeaderCellDef>{{ 'template.sqm' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.sqm }} </mat-cell>
              <mat-footer-cell *matFooterCellDef> {{ property.availableAccomodations.totalSqm }} </mat-footer-cell>
            </ng-container>
            <ng-container matColumnDef="SQFT">
              <mat-header-cell *matHeaderCellDef>{{ 'template.sqft' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.sqft }} </mat-cell>
              <mat-footer-cell *matFooterCellDef> {{ property.availableAccomodations.totalSqft }}</mat-footer-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
            <mat-footer-row *matFooterRowDef="displayedColumns"></mat-footer-row>
          </mat-table>
        </div>
      }
      <h3 class="property-title">{{ 'template.terms' | translate }}</h3>

      @if (property.terms) {
        <div>
          <ul class="navigation-list">
            @for (term of property.terms; track term) {
              <li class="list-item">{{ term.key }}: {{ term.value }}</li>
            }
            @if (property.terms.length === 0) {
              <li class="list-item">N/A</li>
            }
          </ul>
        </div>
      }
      <h3 class="property-title">{{ 'template.conditionAndStatus' | translate }}</h3>

      @if (property.conditionStatus) {
        <div>
          <ul class="navigation-list">
            @for (status of property.conditionStatus; track status) {
              <li class="list-item">{{ status }}</li>
            }
            @if (property.conditionStatus.length === 0) {
              <li class="list-item">N/A</li>
            }
          </ul>
        </div>
      }
      <h3 class="property-title">{{ 'template.summarySpecification' | translate }}</h3>
      @if (property.summarySpecification) {
        <div>
          <ul class="navigation-list">
            @for (summary of property.summarySpecification; track summary) {
              <li class="list-item">{{ summary }}</li>
            }
            @if (property.summarySpecification.length === 0) {
              <li class="list-item">N/A</li>
            }
          </ul>
        </div>
      }
      <ng-template #noSummary>N/A</ng-template>
      <h3 class="property-title">{{ 'template.tenants' | translate }}</h3>
      @if (property.tenants) {
        <div>
          <ul class="navigation-list">
            @for (tenant of property.tenants; track tenant) {
              <li class="list-item">
                {{ tenant.key }}: <u>{{ tenant.value }}</u>
              </li>
            }
            @if (property.tenants.length === 0) {
              <li class="list-item">N/A</li>
            }
          </ul>
        </div>
      }
    </div>
  </div>
